// Sign-in route: signed-in visitors go straight to a safe same-origin redirect (or the start page); password mode signs in with email and password, dev mode continues as the local developer.
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

import { safeRedirect } from "@/app/auth/redirect";
import { SignInPage } from "@/features/auth/SignInPage";

export const Route = createFileRoute("/signin")({
  validateSearch: z.object({ redirect: z.string().optional().catch(undefined) }),
  beforeLoad: ({ context, search }) => {
    if (context.auth.status === "authenticated") {
      throw redirect({ href: safeRedirect(search.redirect) ?? "/", replace: true });
    }
  },
  component: SignInRoute,
});

function SignInRoute() {
  const { redirect: target } = Route.useSearch();
  return <SignInPage redirectTo={target} />;
}
